import SymptomModel from '@/Models/Symptom/SymptomModel';
import LanguageModel from '@/Models/LanguageModel';
import PatientModel from '@/Models/PatientModel';
import StatusReportModel from '@/Models/StatusReportModel';
import StatusTypeModel from '@/Models/StatusTypeModel';
import SymptomReportModel from '@/Models/SymptomReport/SymptomReportModel';
import UserModel from '@/Models/UserModel';

/**
 * @param {EnvironmentViewDto} environment
 * @returns
 */
export const EnvironmentResponse = environment => {
  environment.Languages = environment.Languages.map(
    lang => new LanguageModel(lang)
  );
  environment.StatusTypes = environment.StatusTypes.map(
    type => new StatusTypeModel(type)
  );

  return environment;
};

/**
 * Map remote profile view objects to local
 * @param {ProfileViewDto} profile
 * @returns
 */
export const ProfileResponse = profile => {
  profile.Patient = new PatientModel(profile.Patient);
  profile.User = new UserModel(profile.User);
  return profile;
};

/**
 * @typedef {Object} EnvironmentViewDto
 * @property {Object[]} Constants
 * @property {LanguageModel[]} Languages
 * @property {StatusTypeModel[]} StatusTypes
 */

/**
 * @typedef {Object} ProfileViewDto
 * @property {PatientModel} Patient
 * @property {UserModel} User
 */
